import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "../../redux/store";
import { useRouter } from 'next/router'
import {
  getBookingList,
  getTripList,
  getCancelList,
  bookingAllList,
  bookingListView,
  taxiBookingList,
} from "../../redux/slices/product";
import { Button, CircularProgress } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";

const BookingDetails = ({
  mainActiveTab,
  handleOpen,
  loader,
  setLoader,
  cancelStatus,
  handleBookingCancel,
  bookingData,
  setBookingDetails,
  setActiveTab,
  setDataOne,
  dataOne,
  selectedIndex,
  setLoading,
  loading,
  subActiveTab,
  setSubActiveTab, setItem, item
}) => {
  const dispatch = useDispatch();
  const router = useRouter()
  const { id, type } = router.query
  const {
    bookingListViewRes,
  } = useSelector((state) => state.product);

  // const handleBack = () => {
  //   setBookingDetails(false);
  //   setLoading(true);
  //   setSubActiveTab(Number(sessionStorage.getItem("active-sub-type")));
  //   setDataOne({
  //     ...dataOne,
  //     type: Number(sessionStorage.getItem("active-type")),
  //   });
  //   // setItem({});
  //   //   window.open(
  //   //   `/rsldashboard/bookinglist`, '_self'
  //   // );
  //   // handleBookingCancel("", "")
  // };

  useEffect(() => {
    setActiveTab("");
    setDataOne({ ...dataOne, type: dataOne.type });
  }, []);

  useEffect(() => {

    if (mainActiveTab == 2) {
      setBookingDetails(true);
      const obj = {
        bookingId: bookingData[selectedIndex]?._id,
        bookingType: 2,
      };
      dispatch(bookingListView(obj));
      setItem(bookingListViewRes ? bookingListViewRes : {})
    } else {
      setItem(bookingData[selectedIndex]);
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (type) {
      setItem(bookingData[0])
    }
  }, [type, bookingData])

  useEffect(() => {
    if (cancelStatus !== undefined && loader) {
      setLoader(false);
      if (cancelStatus?.status !== -1) {
        setItem({ ...item, ["bookingStatus"]: cancelStatus?.bookingStatus });
      }
    } else {
      setItem(bookingData[selectedIndex]);
    }
  }, [cancelStatus]);

  const getBookingStatus = (status) => {
    const statusMap = {
      1: { text: "Confirmed", className: "bg-success" },
      0: { text: "Pending", className: "bg-warning" },
      6: { text: "Request for Cancelled", className: "bg-danger" },
      7: { text: "Cancelled", className: "bg-danger" },
    };


    return statusMap[status] ? (
      <span className={`fw-500 font-monospace text-white px-2 py-1 rounded-1 ${statusMap[status].className}`}>
        {statusMap[status].text}
      </span>
    ) : null;
  };

  const getStatus = (status) => {
    const statusMap = {
      1: { text: "Confirmed", className: "bg-success" },
      0: { text: "Created", className: "bg-warning" },
      6: { text: "Request for Cancelled", className: "bg-danger" },
      7: { text: "Cancelled", className: "bg-danger" },
    };

    return statusMap[status] ? (
      <span className={`fw-500 font-monospace text-white px-2 py-1 rounded-1 ${statusMap[status].className}`}>
        {statusMap[status].text}
      </span>
    ) : null;
  };

  const formatBookingDate = (item) => {
    if (item?.type === 2) {
      return moment(item?.bookingDateAndTime).format("YYYY-MM-DD hh:mm");
    }
    if (item?.type === 6 || item?.type === 4) {
      return `${moment(item?.bookingDate).format("YYYY-MM-DD")} ${item?.bookingTime?.trim() ? item.bookingTime : ""}`;
    }
    return moment(item?.bookingDate).format("YYYY-MM-DD");
  };

  return (
    <div className="">
      <div className="row">
        <div className="col-md-8">
          {/* <div>
              <h4 className="my-2">Thank you for your booking!</h4>
              <p className="text-15">Your booking information is below</p>
            </div> */}
          <div className="card dashboard__detailright_card">
            <div className="card-body">
              <h5 className="card-title mb-3">Customer Details:</h5>
              <table>
                <tr>
                  <td className="text-15 w-50">Name:</td>
                  <td className="text-15">{item?.contactDetails?.name}</td>
                </tr>
                <tr>
                  <td className="text-15">Email:</td>
                  <td className="text-15">{item?.contactDetails?.email}</td>
                </tr>
                <tr>
                  <td className="text-15">Phone:</td>
                  <td className="text-15">{item?.contactDetails?.mobile}</td>
                </tr>
                <tr>
                  <td className="text-15">Special Request:</td>
                  <td className="text-15">{item?.contactDetails?.specialRequest ? item.contactDetails.specialRequest : "-"}</td>
                </tr>
              </table>
            </div>
          </div>
          <div className="my-4">
            <div className="card dashboard__detailleft_card">
              <div className="card-body">
                <h5 className="card-title mb-3">
                  {item?.type === 10 ? "Enquiry Details:" : "Package Details:"}
                </h5>

                {/* Activity/Package Details */}
                <div>
                  {/* Title */}
                  <div className="mb-3">
                    {item?.type === 6 ? (
                      <div>
                        <h5 className="text-15">{item?.name}</h5>
                        {item?.packageName && <h5 className="text-15">Package Name: {item?.packageName}</h5>}
                      </div>
                    ) : (
                      <h5 className="text-20">{item?.name}</h5>
                    )}
                    {item?.optionType === 1 ? (
                      // Group display
                      <div className="text-muted text-15">
                        Group: {item?.groupCount || 1} Groups
                      </div>
                    ) : (
                      // People display only if peopleCount has value
                      item?.peopleCount?.count > 0 && (
                        <div className="text-muted text-15">
                          People: {item?.peopleCount?.count} Adults
                        </div>
                      )
                    )}
                  </div>

                  {/* Pickup Point */}
                  {item?.pickupPoint?.address && (
                    <div className="d-flex align-items-center gap-2">
                      <h5 className="text-15">Pickup Point:</h5>
                      <p className="text-15">{item?.pickupPoint?.address || "-"}</p>
                    </div>
                  )}

                  {/* Promo Code */}
                  {item?.promoCode && (
                    <div className="d-flex align-items-center gap-2">
                      <p className="text-15">Promo Code:</p>
                      <h5 className="text-15">{item?.promoCode}</h5>
                    </div>
                  )}

                  {/* Room Details for Type 8 or 4 */}
                  {(item?.type === 8 || item?.type === 4) && (
                    <div className="col-12">
                      <p className="text-15">Room Count: {item?.roomCount || 1}</p>
                      {item?.rooms?.map((room, index) => (
                        <p key={index} className="text-15">
                          Room {index + 1}: {room?.adults} Adults, {room?.children} Children
                        </p>
                      ))}
                    </div>
                  )}
                </div>

                {/* Booking Info */}
                <div className="row mb-3">
                  <div className="col-md-4 text-15">
                    City: <strong>{item?.location}</strong>
                  </div>
                  <div className="col-12 col-md-4">
                    {item?.referenceNumber && item?.referenceNumber?.trim() !== "" && (
                      <p className="text-15">
                        Booking ID: <strong>{item?.referenceNumber}</strong>
                      </p>
                    )}
                    {item?.type === 2 && (
                      <p className="text-15">
                        PNR: <strong>{item?.PNR}</strong>
                      </p>
                    )}
                  </div>
                  <div className="col-12 col-md-4">
                    <p className="text-15">{formatBookingDate(item)}</p>
                  </div>
                  <div className="col-12">
                    <p className="text-15">
                      Status:{" "}
                      <strong>
                        {item?.type === 10
                          ? getStatus(item?.bookingStatus)
                          : getBookingStatus(item?.bookingStatus)}
                      </strong>
                    </p>
                  </div>
                </div>
                {/* Visa Enquiry Block */}
                {item?.type === 10 && (
                  <div className="border-top pt-3 mt-3">
                    {item?.processingType && (
                      <p className="text-15 mb-2">
                        <strong>Processing Type:</strong> {item.processingType}
                      </p>
                    )}
                    {Array.isArray(item?.visaPackageId) && item.visaPackageId.length > 0 && (
                      <div>
                        <h5 className="text-15 mb-2">Visa Packages Selected:</h5>
                        <ul className="ps-3 mb-0">
                          {item.visaPackageId.map((pkg, idx) => (
                            <li key={pkg._id || idx} className="text-15 mb-1">
                              {pkg.title} – <strong>{pkg.numberOfVisa || 1} Visa(s)</strong>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card dashboard__detailright_card">
            <div className="card-body">
              <h5 className="card-title mb-2">Booking Details:</h5>
              <div className="d-flex justify-content-between mb-2">
                <h5 className="text-15">Experience</h5>
                <h5 className="text-15">Price</h5>
              </div>
              <div className="d-flex justify-content-between mb-2 gap-2">
                <div className="text-10" style={{ width: "75%" }}>{item?.name}</div>
                <div className="text-10"> {item?.currency?.toUpperCase()} {item?.actualAmount}</div>
              </div>
              {
                item?.extraPrice !== undefined && item?.extraPrice !== null && item.extraPrice > 0 &&
                <div className="d-flex justify-content-between mb-2 gap-2">
                  <div className="text-10">Extra Price</div>
                  <div className="text-10"> {item?.currency?.toUpperCase()} {item?.extraPrice}</div>
                </div>
              }
              {
                item?.vat !== undefined && item?.vat !== null && item.vat > 0 &&
                <div className="d-flex justify-content-between mb-2 gap-2">
                  <div className="text-10">VAT(5%)</div>
                  <div className="text-10"> {item?.currency?.toUpperCase()} {item?.vat}</div>
                </div>
              }
              {
                item?.promoApplied === 1 &&
                <div className="d-flex justify-content-between mb-2 gap-2">
                  <div className="text-10">Discount Amount</div>
                  <div className="text-10 text-success"> - {item?.currency?.toUpperCase()} {item?.discountAmount}</div>
                </div>
              }
              {/* <div className="d-flex justify-content-between">
                <div className="text-10">Date</div>
                <div className="text-10">
                  {item?.type === 2
                    ? moment(item?.bookingDateAndTime).format("YYYY-MM-DD hh:mm")
                    : (item?.type === 6 || item?.type === 4)
                      ? `${moment(item?.bookingDate).format("YYYY-MM-DD")} ${item?.bookingTime && item.bookingTime !== " " ? item.bookingTime : ""}`
                      : moment(item?.bookingDate).format("YYYY-MM-DD")}
                </div>
              </div> */}
              <div className="d-flex justify-content-between mt-2">
                <h5 className="text-16">Total Price</h5>
                <h5 className="text-16">  {item?.currency?.toUpperCase()} {item?.price ? item.price.toFixed(2) : '0.00'}
                </h5>
              </div>
            </div>
          </div>
          <div className="card dashboard__detailright_card">
            <div className="card-body">
              <div className="d-flex">
                <div className="text-20 mr-3">
                  <img
                    src="/img/dashboard/icons/chatfilled.png"
                    alt="chat"
                    className="w-50"
                  />
                </div>
                <div>
                  <h5 className="text-15 mb-2">We can help you</h5>
                  <p className="text-12 mb-2">
                    Call us +971 43977746 (or) chat with our customer support
                    team
                  </p>
                  <button className="text-10 dashboard__chatbtn">

                    Chat with us
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card dashboard__detailright_card">
            <div className="card-body">
              <div className="text-center mb-3">
                <img
                  src="/img/dashboard/icons/rslphone.png"
                  alt="chat"
                  className="w-50"
                />
              </div>
              <div className="text-center mb-3">
                <h5 className="text-15">Get the App</h5>
                <p>
                  Download our app for better experience and for more
                  features
                </p>
              </div>
              <div className="d-flex text-center justify-content-around">
                <div>

                  <img
                    src="/img/dashboard/icons/appstore.png"
                    alt="chat"
                    className="w-75"
                  />
                </div>
                <div>

                  <img
                    src="/img/dashboard/icons/googleplay.png"
                    alt="chat"
                    className="w-75"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingDetails;
